var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "m-0", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-body",
        [
          _vm.editing
            ? _c(
                "div",
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.descriptionText,
                        expression: "descriptionText",
                      },
                    ],
                    ref: "textarea",
                    staticClass:
                      "w-100 editable-follow-up rich-text-editor--reset p-0",
                    style: "height: " + _vm.height + "px",
                    attrs: { id: "textarea-description-" + _vm.labelValue },
                    domProps: { value: _vm.descriptionText },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.descriptionText = $event.target.value
                        },
                        _vm.handleInput,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-none",
                      attrs: { for: "textarea-description-" + _vm.labelValue },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.actions.enterDescription")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-none",
                      attrs: { for: "foreColorPicker-" + _vm.labelValue },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.words.color")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-none",
                      attrs: { for: "backColorPicker-" + _vm.labelValue },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.words.color")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pb-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "justify-content-end" },
                            [
                              _c(
                                "b-col",
                                { attrs: { xl: "", cols: "12" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "d-flex align-items-end",
                                          attrs: {
                                            xl: "4",
                                            lg: "6",
                                            sm: "6",
                                            cols: "12",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group-material followup-scheduled-date-wrapper m-0",
                                            },
                                            [
                                              _c(
                                                "material-input",
                                                {
                                                  staticClass: "mb-0",
                                                  model: {
                                                    value:
                                                      _vm.followUpScheduledDate,
                                                    callback: function ($$v) {
                                                      _vm.followUpScheduledDate =
                                                        $$v
                                                    },
                                                    expression:
                                                      "followUpScheduledDate",
                                                  },
                                                },
                                                [
                                                  _c("datepicker-input", {
                                                    attrs: {
                                                      name: "closing-date",
                                                      "show-calendar": false,
                                                      placeholder: "YYYY-MM-DD",
                                                      "future-date": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.followUpScheduledDate,
                                                      callback: function ($$v) {
                                                        _vm.followUpScheduledDate =
                                                          $$v
                                                      },
                                                      expression:
                                                        "followUpScheduledDate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "d-flex align-items-end",
                                          attrs: {
                                            xxl: "4",
                                            xl: "3",
                                            lg: "6",
                                            sm: "6",
                                            cols: "12",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group-material followup-scheduled-date-wrapper m-0 vertical-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bold text-regular-gray tiny text-uppercase mr-4 mt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.at"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-container form-group-material form-group-material-no-label position-relative fe-dp",
                                                },
                                                [
                                                  _c("time-input", {
                                                    attrs: {
                                                      id: _vm.labelValue,
                                                      "default-value":
                                                        _vm.followUpNotificationTime,
                                                      label:
                                                        _vm.$t(
                                                          "global.words.time"
                                                        ),
                                                      "hidden-label": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.followUpScheduledTime,
                                                      callback: function ($$v) {
                                                        _vm.followUpScheduledTime =
                                                          $$v
                                                      },
                                                      expression:
                                                        "followUpScheduledTime",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-xl-0 mt-4 pt-xl-0 pt-2",
                                  attrs: {
                                    xl: "auto",
                                    lg: "6",
                                    sm: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "float-right add-list mt-3",
                                      attrs: {
                                        variant: "primary",
                                        size: "sm",
                                        disabled: !_vm.canSave,
                                      },
                                      on: { click: _vm.handleSubmit },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("global.actions.saveChanges")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("html-iframe-preview", {
                staticClass:
                  "follow-up-description rich-text-editor--reset p-0",
                attrs: {
                  content: _vm.sanitizedDescriptionText,
                  "break-content-words": "",
                },
                on: {
                  dblclick: function ($event) {
                    $event.preventDefault()
                    return _vm.editFollowUp.apply(null, arguments)
                  },
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.editing
        ? _c(
            "b-card-footer",
            [
              _c("timeline-card-footer", {
                attrs: { pinned: _vm.pinned },
                on: {
                  pinned: function ($event) {
                    return _vm.handlePin(_vm.id, _vm.activityType, _vm.pinned)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "left",
                      fn: function () {
                        return [
                          _c(
                            "b-col",
                            {
                              staticClass: "vertical-center mb-md-0 mb-2",
                              attrs: { cols: "12", md: "auto" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "vertical-center" },
                                [
                                  _c(
                                    "profile-avatar",
                                    _vm._b(
                                      {
                                        staticClass:
                                          "client-profile-owner-avatar mr-2",
                                        attrs: {
                                          "avatar-options": { inline: true },
                                        },
                                      },
                                      "profile-avatar",
                                      Object.assign({}, _vm.creator),
                                      false
                                    )
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "mr-1" }, [
                                    _vm._v(_vm._s(_vm.name)),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.notUpdatedYet
                                ? _c("i18n", {
                                    staticClass: "text-lowercase",
                                    attrs: {
                                      path: "global.actions.hasCreatedAn",
                                      tag: "span",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-secondary bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "global.words.activity",
                                                          1
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3973597571
                                    ),
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("global.words.updated")) +
                                        "\n            "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-secondary bold" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$tc(
                                                "global.words.activity",
                                                1
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "vertical-center mb-md-0 mb-2",
                              attrs: { cols: "12", md: "auto" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "px-2 d-none d-md-inline" },
                                [_vm._v("-")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("momentLocal")(
                                        _vm.updatedAt,
                                        "MMM. DD, YYYY"
                                      )
                                    ) +
                                    " @\n            " +
                                    _vm._s(
                                      _vm._f("momentLocal")(_vm.updatedAt, "LT")
                                    ) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "px-2 d-none d-md-inline" },
                                [_vm._v("|")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "vertical-center",
                              attrs: { cols: "12", md: "auto" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "pretty p-icon p-smooth mx-0" },
                                [
                                  _c("input", {
                                    staticClass: "valid follow-up-complete",
                                    attrs: {
                                      id: _vm.isPinned
                                        ? "new-follow-up-complete-" +
                                          _vm.id +
                                          "-pinned"
                                        : "new-follow-up-complete-" + _vm.id,
                                      "follow-up-id": _vm.id,
                                      type: "checkbox",
                                    },
                                    domProps: { checked: _vm.isComplete },
                                    on: { change: _vm.completeFollowUp },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "state p-primary p-success",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-light-gray clickable",
                                          attrs: {
                                            for: _vm.isPinned
                                              ? "new-follow-up-complete-" +
                                                _vm.id +
                                                "-pinned"
                                              : "new-follow-up-complete-" +
                                                _vm.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("global.words.complete")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "b-col",
                            {
                              staticClass: "vertical-center",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "bold text-regular-gray mr-1 mt-0",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("global.words.due")) +
                                      ":\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  ref: "scheduledDate",
                                  staticClass: "followup-scheduled-date",
                                  class: _vm.scheduledCssClass,
                                  on: {
                                    dblclick: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editScheduledDate.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("momentLocal")(
                                          _vm.followUpScheduledDate,
                                          "MMM. DD, YYYY"
                                        )
                                      ) +
                                      " @\n            " +
                                      _vm._s(_vm.formattedScheduledTime) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex flex-row align-items-center justify-content-end justify-content-md-start",
                              attrs: { col: "", md: "auto" },
                            },
                            [
                              _c("div", { staticClass: "dropleft" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "grey-text text-darken-4 clickable vertical-center",
                                    attrs: { "data-toggle": "dropdown" },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("more_vert"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item clickable text-primary edit-follow-up",
                                      attrs: { "data-follow-up-id": _vm.id },
                                      on: { click: _vm.editFollowUp },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "client-profile.actions.editActivity"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "dropdown-divider",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "inline-prompt",
                                        {
                                          attrs: {
                                            placement: "left",
                                            "confirmation-text": _vm.$t(
                                              "client-profile.messages.deleteConfirmation",
                                              {
                                                item: _vm.$tc(
                                                  "global.words.activity",
                                                  1
                                                ),
                                              }
                                            ),
                                          },
                                          on: { accept: _vm.handleDelete },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item clickable text-danger btn-danger remove-followup",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "client-profile.actions.deleteActivity"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3610224640
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }